(function () {
  const root = document.body;
  if (!root.classList.contains('template-index')) return;

  const hero = document.querySelector('[data-homepage-hero]');
  if (!hero) return;

  const slides = Array.from(hero.querySelectorAll('[data-homepage-hero-slide]'));
  const dots = Array.from(hero.querySelectorAll('.homepage-hero__dot'));
  if (slides.length <= 1) return;

  const autoplay = hero.dataset.autoplay === 'true';
  const speed = (parseInt(hero.dataset.speed, 10) || 4) * 1000;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  let index = 0;
  let timer = null;

  function setActive(nextIndex) {
    index = nextIndex;
    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  }

  function nextSlide() {
    setActive((index + 1) % slides.length);
  }

  function play() {
    if (!autoplay || reducedMotion.matches) return;
    clearInterval(timer);
    timer = setInterval(nextSlide, speed);
  }

  function pause() {
    clearInterval(timer);
    timer = null;
  }

  hero.addEventListener('mouseenter', pause);
  hero.addEventListener('mouseleave', play);
  hero.addEventListener('focusin', pause);
  hero.addEventListener('focusout', play);

  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) {
      pause();
    } else {
      play();
    }
  });

  play();
})();
